export enum ProductArea {
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_UNASSIGNED
   */
  PRODUCT_AREA_UNKNOWN = 'PRODUCT_AREA_UNKNOWN',
  /**
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "About Us Page"
   */
  ABOUT_US_PAGE = 'ABOUT_US_PAGE',
  /**
   * @protobufOption (description) = "Admin Authorization"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Admin Authorization"
   */
  ADMIN = 'ADMIN',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  ADYEN = 'ADYEN',
  /**
   * @protobufOption (description) = "Adyen brand side integration (Adyen for Platforms)"
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Adyen Payout"
   */
  ADYEN_PAYOUT = 'ADYEN_PAYOUT',
  /**
   * @protobufOption (description) = "Stripe brand side integration (Stripe Connect platform)"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Stripe Payout"
   */
  STRIPE_PAYOUT = 'STRIPE_PAYOUT',
  /**
   * @protobufOption (description) = "Affiliate program run through Impact"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Affiliates"
   */
  AFFILIATES = 'AFFILIATES',
  /**
   * @protobufOption (description) = "AI Bridge is a service that provides an interface for executing ML models"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "AI Bridge"
   */
  AI_BRIDGE = 'AI_BRIDGE',
  /**
   * @protobufOption (description) = "AI Tools a Burrito-wrapper for our internal Python/LLM tools"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "AI Tools"
   */
  AI_TOOLS = 'AI_TOOLS',
  /**
   * @protobufOption (description) = "Alcohol sales, category restrictions related to alcohol"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Alcohol"
   */
  ALCOHOL = 'ALCOHOL',
  /**
   * @protobufOption (description) = "Alert banners for brands and retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Alert Banners"
   */
  ALERT_BANNERS = 'ALERT_BANNERS',
  /**
   * @protobufOption (description) = "AMEX sign up offer landing page"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Amex landing page"
   */
  AMEX = 'AMEX',
  /**
   * @protobufOption (pod) = FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Anti-Abuse"
   */
  ANTI_ABUSE = 'ANTI_ABUSE',
  /**
   * @protobufOption (description) = "Api Performance and Metrics"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Api Performance"
   */
  API_PERFORMANCE = 'API_PERFORMANCE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  APPAREL_BRAND = 'APPAREL_BRAND',
  /**
   * @protobufOption (description) = "Apparel Collections are Product Based Collections catered for Apparel Brands"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Apparel Product Based Collections"
   */
  APPAREL_COLLECTIONS = 'APPAREL_COLLECTIONS',
  /**
   * @protobufOption (description) = "Core Product Based Collections are Product Based Collections catered for Non-Apparel Brands and Retailers"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Core Product Based Collections"
   */
  CORE_COLLECTIONS = 'CORE_COLLECTIONS',
  /**
   * @protobufOption (description) = "Retailer-facing display logic for Product Based Collections"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Collections Retailer Display"
   */
  COLLECTIONS_RETAILER_DISPLAY = 'COLLECTIONS_RETAILER_DISPLAY',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   */
  APPAREL_DISCOVERY = 'APPAREL_DISCOVERY',
  /**
   * @protobufOption (description) = "Internal tool for managing multiservices. Contains Goose."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Appdash"
   */
  APPDASH = 'APPDASH',
  /**
   * @protobufOption (description) = "Specific to the L'Atelier Faire event"
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   * @protobufOption (title) = "L'Atelier Faire"
   */
  ATELIER_FAIRE = 'ATELIER_FAIRE',
  /**
   * @protobufOption (description) = "User authentication."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Authentication"
   */
  AUTH = 'AUTH',
  /**
   * @protobufOption (description) = "Anything that has to do with multi-factor authentication or login codes."
   * @protobufOption (pod) = FAIRE_POD_ANTI_ABUSE
   * @protobufOption (title) = "MFA"
   */
  MFA = 'MFA',
  /**
   * @protobufOption (description) = "Build, train, and deploy machine learning models"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "AWS Sagemaker"
   */
  AWS_SAGEMAKER = 'AWS_SAGEMAKER',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   * @protobufOption (title) = "B2B Referrals"
   */
  B2B_REFERRALS = 'B2B_REFERRALS',
  /**
   * @protobufOption (description) = "Framework for backend-controlled UI messaging components and dynamic frontend content delivery."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Backend-Driven Messaging Containers"
   */
  BACKEND_DRIVEN_MESSAGING_CONTAINERS = 'BACKEND_DRIVEN_MESSAGING_CONTAINERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   */
  BACKFILA = 'BACKFILA',
  /**
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   */
  BADGES = 'BADGES',
  /**
   * @deprecated
   * @protobufOption (description) = "Gated content that requires a brand to register, typically linked to from the Faire blog"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Blog Gated Content"
   */
  BLOG_GATED_CONTENT = 'BLOG_GATED_CONTENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   */
  BOARDS = 'BOARDS',
  /**
   * @protobufOption (description) = "Settings and features related to a brand's account"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand Account Settings"
   */
  BRAND_ACCOUNT_SETTINGS = 'BRAND_ACCOUNT_SETTINGS',
  /**
   * @protobufOption (description) = "Areas related to acquiring brands"
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   * @protobufOption (title) = "Brand Acquisition"
   */
  BRAND_ACQUISITION = 'BRAND_ACQUISITION',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  BRAND_ANALYTICS = 'BRAND_ANALYTICS',
  /**
   * @protobufOption (description) = "Areas related to the product sales report related analytics"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand Analytics Product Sales Report"
   */
  PRODUCT_SALES_REPORT = 'PRODUCT_SALES_REPORT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  BRAND_ANNOUNCEMENTS = 'BRAND_ANNOUNCEMENTS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_APP = 'BRAND_APP',
  /**
   * @protobufOption (description) = "Areas related to the completeness of the brand's catalog"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand catalog completeness"
   */
  BRAND_CATALOG_COMPLETENESS = 'BRAND_CATALOG_COMPLETENESS',
  /**
   * @protobufOption (description) = "Core brand resources that cannot be assigned to a more specific product area"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  BRAND_CORE = 'BRAND_CORE',
  /**
   * @protobufOption (pod) = FAIRE_POD_RELATIONSHIP_GROWTH
   */
  BRAND_CRM = 'BRAND_CRM',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY = 'BRAND_CUSTOMER_ENGAGEMENT_SURVEY',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_DAILY_DIGEST = 'BRAND_DAILY_DIGEST',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_EMAIL_PREFERENCES = 'BRAND_EMAIL_PREFERENCES',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_F14D_DISCOUNTS = 'BRAND_F14D_DISCOUNTS',
  /**
   * @protobufOption (description) = "This feature allows us to check if a brand is a good quality brand and not fraudulent during the brand onboarding process."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand Fraud"
   */
  BRAND_FRAUD = 'BRAND_FRAUD',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_DATA
   */
  BRAND_HYPE_MAP = 'BRAND_HYPE_MAP',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_INTEGRATIONS = 'BRAND_INTEGRATIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_INVOICES = 'BRAND_INVOICES',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_LEADS = 'BRAND_LEADS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  BRAND_LISTING_QUALITY = 'BRAND_LISTING_QUALITY',
  /**
   * @protobufOption (description) = "Features related to brand loyalty programs such as Faire Direct Rewards and Top Shop. Faire Direct Rewards loyalty program has ended, therefore new work should be done in Top Shop."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand Loyalty Programs"
   */
  BRAND_LOYALTY = 'BRAND_LOYALTY',
  /**
   * @protobufOption (pod) = FAIRE_POD_RELATIONSHIP_GROWTH
   */
  BRAND_MARKETING_CAMPAIGNS = 'BRAND_MARKETING_CAMPAIGNS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   */
  BRAND_MARKETPLACE = 'BRAND_MARKETPLACE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_MARKETPLACE_HOMEPAGE = 'BRAND_MARKETPLACE_HOMEPAGE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Faire Brand App"
   */
  BRAND_MOBILE = 'BRAND_MOBILE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_MULTI_USER_MANAGEMENT = 'BRAND_MULTI_USER_MANAGEMENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  BRAND_NUDGES = 'BRAND_NUDGES',
  /**
   * @protobufOption (description) = "Areas related to onboarding new brands to the Faire platform"
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   * @protobufOption (title) = "Brand Onboarding"
   */
  BRAND_ONBOARDING = 'BRAND_ONBOARDING',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_ORDERS = 'BRAND_ORDERS',
  /**
   * @protobufOption (description) = "Calculating Payouts to brands."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Payout calculation"
   */
  BRAND_PAYOUT_CALCULATION = 'BRAND_PAYOUT_CALCULATION',
  /**
   * @protobufOption (description) = "Payouts to brands (only payout creation/initiation without payout infrastructure)"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand payouts"
   */
  BRAND_PAYOUTS = 'BRAND_PAYOUTS',
  /**
   * @protobufOption (description) = "Components of the brand portal homepage"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand portal homepage"
   */
  BRAND_PORTAL_HOMEPAGE = 'BRAND_PORTAL_HOMEPAGE',
  /**
   * @protobufOption (description) = "Brand portal products search"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand portal search"
   */
  BRAND_PORTAL_SEARCH = 'BRAND_PORTAL_SEARCH',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_PORTAL_NAVIGATION = 'BRAND_PORTAL_NAVIGATION',
  /**
   * @protobufOption (description) = "AKA View My Shop. Allows brands to see their own brand page"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Preview"
   */
  BRAND_PREVIEW = 'BRAND_PREVIEW',
  /**
   * @protobufOption (description) = "Pricing of products on Faire. This includes MSRP, Wholesale price, and any pricing rules that apply to products listed by brands on the Faire platform."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand Product Pricing"
   */
  BRAND_PRICING = 'BRAND_PRICING',
  /**
   * @protobufOption (description) = "The suggested search queries that appear when a retailer types search requests on the brand page"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Brand Product Search Suggestions"
   */
  BRAND_PRODUCT_SEARCH_SUGGESTIONS = 'BRAND_PRODUCT_SEARCH_SUGGESTIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  BRAND_PROMOS = 'BRAND_PROMOS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_PROSPECTING = 'BRAND_PROSPECTING',
  /**
   * @protobufOption (description) = "Allows brands to choose the countries from which retailers can buy their products"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Brand restrictions"
   */
  BRAND_RESTRICTIONS = 'BRAND_RESTRICTIONS',
  /**
   * @protobufOption (description) = "Brand-level reviews and ratings from retailers. This feature covers the collection, display, and management of reviews for brands on the Faire platform."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand Reviews"
   */
  BRAND_REVIEWS = 'BRAND_REVIEWS',
  /**
   * @protobufOption (description) = "Brand Safety features that ensure a trustworthy marketplace for retailers and brands. This includes mechanisms to detect and prevent counterfeit products, products containing sensitive content, and maintain high standards for brand quality."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand Safety"
   */
  BRAND_SAFETY = 'BRAND_SAFETY',
  /**
   * @protobufOption (description) = "Searching for brands on Faire (not a brand's products)"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Brand Search"
   */
  BRAND_SEARCH = 'BRAND_SEARCH',
  /**
   * @protobufOption (description) = "Logic that allows brands to view the brand portal in currencies other than USD"
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand shop currency"
   */
  BRAND_SHOP_CURRENCY = 'BRAND_SHOP_CURRENCY',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_SHOP_PAGE = 'BRAND_SHOP_PAGE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_SHOP_SETTINGS = 'BRAND_SHOP_SETTINGS',
  /**
   * @deprecated
   * @protobufOption (description) = "Deprecated, use a more specific product area."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  BRAND_SHOPIFY_INTEGRATION = 'BRAND_SHOPIFY_INTEGRATION',
  /**
   * @protobufOption (description) = "Shopify catalog management for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Catalog Sync"
   */
  BRAND_SHOPIFY_CATALOG_SYNC = 'BRAND_SHOPIFY_CATALOG_SYNC',
  /**
   * @protobufOption (description) = "Shopify metafields sync for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Brand Shopify Metafields Sync"
   */
  BRAND_SHOPIFY_METAFIELDS_SYNC = 'BRAND_SHOPIFY_METAFIELDS_SYNC',
  /**
   * @protobufOption (description) = "Product content sync for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Content Sync"
   */
  BRAND_SHOPIFY_CONTENT_SYNC = 'BRAND_SHOPIFY_CONTENT_SYNC',
  /**
   * @protobufOption (description) = "Homepage on Shopify for the brand Shopify integration, such as banners, home resources, link summaries"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Home"
   */
  BRAND_SHOPIFY_HOME = 'BRAND_SHOPIFY_HOME',
  /**
   * @protobufOption (description) = "Shopify inventory sync for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Inventory Sync"
   */
  BRAND_SHOPIFY_INVENTORY_SYNC = 'BRAND_SHOPIFY_INVENTORY_SYNC',
  /**
   * @protobufOption (description) = "Shopify order sync for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand Shopify Order Sync"
   */
  BRAND_SHOPIFY_ORDER_SYNC = 'BRAND_SHOPIFY_ORDER_SYNC',
  /**
   * @protobufOption (description) = "Managing preferences for the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand Shopify Preferences"
   */
  BRAND_SHOPIFY_PREFERENCES = 'BRAND_SHOPIFY_PREFERENCES',
  /**
   * @protobufOption (description) = "Product price syncing from Shopify to Faire"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Price Sync"
   */
  BRAND_SHOPIFY_PRICE_SYNC = 'BRAND_SHOPIFY_PRICE_SYNC',
  /**
   * @protobufOption (description) = "Migrating brands from the old brand integration to the Sales Channel one"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Sales Channel Migration"
   */
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION = 'BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION',
  /**
   * @protobufOption (description) = "Installation and setup of the brand Shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Setup"
   */
  BRAND_SHOPIFY_SETUP = 'BRAND_SHOPIFY_SETUP',
  /**
   * @protobufOption (description) = "Changes limited to the embedded retailer Shopify app. Actual features of the retailer integration (e.g, syncing over ordered products) should use RETAILER_POS_INTEGRATIONS."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   */
  RETAILER_SHOPIFY_APP = 'RETAILER_SHOPIFY_APP',
  /**
   * @protobufOption (description) = "Brand Service Level Agreement (SLA) features that help maintain high standards for brand performance on the Faire platform. This includes monitoring and enforcing SLAs related to order fulfillment, customer service, and overall brand reliability."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Brand SLA"
   */
  BRAND_SLA = 'BRAND_SLA',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  BRAND_TAGS = 'BRAND_TAGS',
  /**
   * @protobufOption (description) = "Tile representation of a brand used on brand first results such as carousels recommending brands, brand first category results grid and brand first search results grid."
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Brand tile"
   */
  BRAND_TILE = 'BRAND_TILE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_VERIFICATION = 'BRAND_VERIFICATION',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  BRAND_WIDGET = 'BRAND_WIDGET',
  /**
   * @deprecated
   * @protobufOption (description) = "Deprecated, use a more specific product area."
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   */
  BRANDS = 'BRANDS',
  /**
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   */
  BRAZE = 'BRAZE',
  /**
   * @protobufOption (description) = "Faire Browser Extension (Chrome + Firefox)"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Faire Browser Extension"
   */
  BROWSER_EXTENSION = 'BROWSER_EXTENSION',
  /**
   * @protobufOption (description) = "Buy it again page or carousel"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Buy it again"
   */
  BUY_IT_AGAIN = 'BUY_IT_AGAIN',
  /**
   * @protobufOption (description) = "Bulk action internal framework."
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Bulk Actions"
   */
  BULK_ACTIONS = 'BULK_ACTIONS',
  /**
   * @protobufOption (description) = "User capabilities, teams and permissions."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Capabilities"
   */
  CAPABILITIES = 'CAPABILITIES',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   */
  CARBON_NEUTRAL_RETAILER = 'CARBON_NEUTRAL_RETAILER',
  /**
   * @protobufOption (description) = "Retailer cart."
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Cart"
   */
  CART = 'CART',
  /**
   * @protobufOption (description) = "Product recommendations to surface in a retailer's cart."
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Cart Recommendations"
   */
  CART_RECOMMENDATIONS = 'CART_RECOMMENDATIONS',
  /**
   * @protobufOption (description) = "Retailer cart collaborators and reviews."
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Cart Collaboration"
   */
  CART_COLLABORATION = 'CART_COLLABORATION',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT
   */
  CATEGORIES = 'CATEGORIES',
  /**
   * @protobufOption (description) = "Generate/show/hide category page layouts"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Category page layouts"
   */
  CATEGORY_PAGE_RECOMMENDATIONS = 'CATEGORY_PAGE_RECOMMENDATIONS',
  /**
   * @protobufOption (description) = "Related to the infrastructure that powers Faire's browsing surfaces"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "browse Infrastructure"
   */
  BROWSE_INFRASTRUCTURE = 'BROWSE_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "Category page search results"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Category results page"
   */
  CATEGORY_RESULTS = 'CATEGORY_RESULTS',
  /**
   * @protobufOption (description) = "Ranking logic/rules for category page results"
   * @protobufOption (pod) = FAIRE_POD_PERSONALIZATION
   * @protobufOption (title) = "Category results ranking"
   */
  CATEGORY_RESULTS_RANKING = 'CATEGORY_RESULTS_RANKING',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Code related to migrating from monolith -> catalogs service"
   */
  CATALOGS_MIGRATION = 'CATALOGS_MIGRATION',
  /**
   * @protobufOption (description) = "Verification of brand submitted catalogs for pricing and completeness"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Catalog Verification"
   */
  CATALOG_VERIFICATION = 'CATALOG_VERIFICATION',
  /**
   * @protobufOption (description) = "Enterprise solutions for Chat GPT"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Chat GPT Enterprise"
   */
  CHAT_GPT_ENTERPRISE = 'CHAT_GPT_ENTERPRISE',
  /**
   * @protobufOption (description) = "Checkout flow for retailers."
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   * @protobufOption (title) = "Checkout"
   */
  CHECKOUT = 'CHECKOUT',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  CLAWBACKS = 'CLAWBACKS',
  /**
   * @protobufOption (description) = "Anything related to our client event analytics or PETE"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Client Events"
   */
  CLIENT_EVENTS = 'CLIENT_EVENTS',
  /**
   * @protobufOption (description) = "Tool to allow pillars and pods to view client health metrics"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Client Health Tool"
   */
  CLIENT_HEALTH_TOOL = 'CLIENT_HEALTH_TOOL',
  /**
   * @protobufOption (description) = "Migration of MySQL database to Cockroach DB"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Cockroach DB"
   */
  COCKROACH_DB = 'COCKROACH_DB',
  /**
   * @deprecated
   * @protobufOption (description) = "DEPRECATED. Use either PREPACKS or CORE_COLLECTIONS."
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "(Deprecated) Starter Collections"
   */
  COLLECTIONS = 'COLLECTIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  COMMISSIONS = 'COMMISSIONS',
  /**
   * @protobufOption (description) = "Anything related to outgoing communication planner"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Outgoing Comms Planner"
   */
  COMMS_PLANNER = 'COMMS_PLANNER',
  /**
   * @protobufOption (description) = "The Conductor UI Orchestration System (Docs to be added)"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Conductor"
   */
  CONDUCTOR = 'CONDUCTOR',
  /**
   * @deprecated
   * @protobufOption (description) = "DEPRECATED. Neighborhood, Faire's, direct-to-consumer marketplace."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Consumer"
   */
  CONSUMER = 'CONSUMER',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  CSV_IMPORT = 'CSV_IMPORT',
  /**
   * @protobufOption (description) = "Logic for converting monetary amounts between currencies"
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Currency conversion"
   */
  CURRENCY_CONVERSION = 'CURRENCY_CONVERSION',
  /**
   * @protobufOption (description) = "Various customer queues used by CX to handle incoming tickets"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "CX Customer Queues"
   */
  CX_CUSTOMER_QUEUES = 'CX_CUSTOMER_QUEUES',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "CX Foundations"
   */
  CX_FOUNDATIONS = 'CX_FOUNDATIONS',
  /**
   * @protobufOption (description) = "Area to manage first order incentives for retailers."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "First Order Incentive"
   */
  RETAILER_FIRST_ORDER_INCENTIVE = 'RETAILER_FIRST_ORDER_INCENTIVE',
  /**
   * @protobufOption (description) = "Area to manage every incentive of the Retailer Activation pod."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Retailer Activation Incentives"
   */
  RETAILER_ACTIVATION_INCENTIVES = 'RETAILER_ACTIVATION_INCENTIVES',
  /**
   * @protobufOption (description) = "Anything related to CX operations, zendesk etc"
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "CX Operations"
   */
  CX_OPS = 'CX_OPS',
  /**
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Atlas"
   */
  DATA_ATLAS = 'DATA_ATLAS',
  /**
   * @protobufOption (description) = "Data Science data sets loading and management."
   * @protobufOption (pod) = FAIRE_POD_DATA
   * @protobufOption (title) = "Data Factory"
   */
  DATA_FACTORY = 'DATA_FACTORY',
  /**
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Lake"
   */
  DATA_LAKE = 'DATA_LAKE',
  /**
   * @protobufOption (pod) = FAIRE_POD_DATA
   */
  DATA_LOOKUP = 'DATA_LOOKUP',
  /**
   * @protobufOption (description) = "Relational database persistence. Core infrastructure."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Database"
   */
  DATABASE = 'DATABASE',
  /**
   * @protobufOption (description) = "Tool to explorer our DB https://www.faire.com/admin2/eng/db-explorer"
   * @protobufOption (pod) = FAIRE_POD_DATA
   * @protobufOption (title) = "Database Explorer"
   */
  DATABASE_EXPLORER = 'DATABASE_EXPLORER',
  /**
   * @protobufOption (description) = "Delayed jobs management"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Delayer"
   */
  DELAYER = 'DELAYER',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  DRAFT_ORDERS = 'DRAFT_ORDERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  RETAILER_DRAFT_ORDERS = 'RETAILER_DRAFT_ORDERS',
  /**
   * @protobufOption (description) = "Customs duties and tax calculations for international shipments and cross-border commerce."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Customs Duties"
   */
  DUTIES = 'DUTIES',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   */
  E2E = 'E2E',
  /**
   * @deprecated
   * @protobufOption (description) = "Sustainability Hub and Eco-friendly brand tags and product attributes"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Eco-friendly Experience"
   */
  ECO_FRIENDLY = 'ECO_FRIENDLY',
  /**
   * @protobufOption (description) = "Core infrastructure and framework running on the edge network"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Edge Worker Infrastructure"
   */
  EDGE_INFRA = 'EDGE_INFRA',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  EDIT_ORDERS = 'EDIT_ORDERS',
  /**
   * @protobufOption (description) = "Infrastructure related to emails"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Email Infrastructure"
   */
  EMAIL_INFRA = 'EMAIL_INFRA',
  /**
   * @protobufOption (description) = "Triage product area used for PR bot to assign DD monitor error tickets to correct pod."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "DD Monitor Error Ticket to Pod Triage"
   */
  ERROR_RATE_TRIAGE = 'ERROR_RATE_TRIAGE',
  /**
   * @protobufOption (description) = "Event producer and consumer core framework."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Events"
   */
  EVENTS = 'EVENTS',
  /**
   * @protobufOption (description) = "Exclusivity feature for Retailers and Brands."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Exclusivity"
   */
  EXCLUSIVITY = 'EXCLUSIVITY',
  /**
   * @protobufOption (description) = "Tooling for running experiments"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Experiments"
   */
  EXPERIMENTS = 'EXPERIMENTS',
  /**
   * @protobufOption (description) = "Experiment Platform"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Experiment Platform"
   */
  EXPERIMENT_PLATFORM = 'EXPERIMENT_PLATFORM',
  /**
   * @protobufOption (description) = "Product Area for PR Bot to assign Expired Settings Jira tickets"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Expired Settings Cleanup"
   */
  EXPIRED_SETTINGS_CLEANUP = 'EXPIRED_SETTINGS_CLEANUP',
  /**
   * @deprecated
   * @protobufOption (description) = "DEPRECATED: Use `EXERNAL_API_XXX` instead for specific features"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  EXTERNAL_APIS = 'EXTERNAL_APIS',
  /**
   * @protobufOption (description) = "External API support for Brand functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "External API - Brands"
   */
  EXTERNAL_API_BRANDS = 'EXTERNAL_API_BRANDS',
  /**
   * @protobufOption (description) = "External API core shared functionality, e.g. ratelimiters"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "External API - Core"
   */
  EXTERNAL_API_CORE = 'EXTERNAL_API_CORE',
  /**
   * @protobufOption (description) = "External API support for Brand Promotions functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "External API - Brands"
   */
  EXTERNAL_API_BRAND_PROMOS = 'EXTERNAL_API_BRAND_PROMOS',
  /**
   * @protobufOption (description) = "External API support for Orders functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "External API - Orders"
   */
  EXTERNAL_API_ORDERS = 'EXTERNAL_API_ORDERS',
  /**
   * @protobufOption (description) = "External Api OAuth for installing apps for brands via OAuth protocol"
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "External API OAuth"
   */
  EXTERNAL_API_OAUTH = 'EXTERNAL_API_OAUTH',
  /**
   * @protobufOption (description) = "External API support for partnerships functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "External API - Partnerships"
   */
  EXTERNAL_API_PARTNERSHIPS = 'EXTERNAL_API_PARTNERSHIPS',
  /**
   * @protobufOption (description) = "External API support for Product model functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "External API - Products"
   */
  EXTERNAL_API_PRODUCTS = 'EXTERNAL_API_PRODUCTS',
  /**
   * @protobufOption (description) = "External API support for Prepack functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "External API - Prepacks"
   */
  EXTERNAL_API_PREPACKS = 'EXTERNAL_API_PREPACKS',
  /**
   * @protobufOption (description) = "External API support for product inventory functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "External API - Inventory"
   */
  EXTERNAL_API_PRODUCT_INVENTORY = 'EXTERNAL_API_PRODUCT_INVENTORY',
  /**
   * @protobufOption (description) = "External API support for retailers functionality"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "External API - Retailers"
   */
  EXTERNAL_API_RETAILERS = 'EXTERNAL_API_RETAILERS',
  /**
   * @protobufOption (description) = "External API support for product taxonomy functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "External API - Taxonomy"
   */
  EXTERNAL_API_TAXONOMY = 'EXTERNAL_API_TAXONOMY',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  EXTERNAL_DEVELOPER = 'EXTERNAL_DEVELOPER',
  /**
   * @protobufOption (description) = "Fairey chatbot infrastructure, such as integrations and prompt factories."
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Fairey"
   */
  FAIREY = 'FAIREY',
  /**
   * @protobufOption (description) = "Faire CLI, for various command-line utilities."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Faire CLI"
   */
  FAIRE_CLI = 'FAIRE_CLI',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  FAIRE_CONTENT = 'FAIRE_CONTENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  FAIRE_DIRECT = 'FAIRE_DIRECT',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  FAIRE_DIRECT_ADOPTION_EMAIL = 'FAIRE_DIRECT_ADOPTION_EMAIL',
  /**
   * @protobufOption (description) = "iPad App for brands to write invoices for retailers at trade shows"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Faire Direct App"
   */
  FAIRE_DIRECT_APP = 'FAIRE_DIRECT_APP',
  /**
   * @deprecated
   * @protobufOption (description) = "Area specific to Faire Direct retailers"
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   * @protobufOption (title) = "Faire Direct Retailers"
   */
  FAIRE_DIRECT_RETAILERS = 'FAIRE_DIRECT_RETAILERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  FAIRE_DIRECT_REWARDS = 'FAIRE_DIRECT_REWARDS',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL = 'FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  FAIRE_DIRECT_TRIGGER_EMAIL = 'FAIRE_DIRECT_TRIGGER_EMAIL',
  /**
   * @deprecated
   * @protobufOption (description) = "Shut down due to lack of an owner."
   * @protobufOption (pod) = FAIRE_POD_INTERNAL_TOOLS
   */
  FAIRE_FOLK_HUB = 'FAIRE_FOLK_HUB',
  /**
   * @deprecated
   * @protobufOption (description) = "Fetching and returning TrustPilot information"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "TrustPilot integration"
   */
  FAIRE_SOCIAL_PROOF = 'FAIRE_SOCIAL_PROOF',
  /**
   * Faire Spaces was a hack week project https://www.notion.so/faire/Faire-Spaces-The-Faire-Office-App-52628a7b69f048dd9253a42c768bdeb8
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_MOBILE_CORE
   */
  FAIRE_SPACES = 'FAIRE_SPACES',
  /**
   * @protobufOption (description) = "Integrations for retailer side"
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  RETAILER_POS_INTEGRATIONS = 'RETAILER_POS_INTEGRATIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  FAIRESYNC = 'FAIRESYNC',
  /**
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  FAIRESYNC_INTEGRATION_CLOVER = 'FAIRESYNC_INTEGRATION_CLOVER',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  FAIRESYNC_INTEGRATION_SHOPIFY = 'FAIRESYNC_INTEGRATION_SHOPIFY',
  /**
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  FAIRESYNC_INTEGRATION_SQUARE = 'FAIRESYNC_INTEGRATION_SQUARE',
  /**
   * @deprecated
   * @protobufOption (description) = "We never launched this brand integration with Quickbooks and we removed all its code"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  FAIRESYNC_INTEGRATION_QUICKBOOKS = 'FAIRESYNC_INTEGRATION_QUICKBOOKS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  FAIREWORKS = 'FAIREWORKS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_UPMARKET_TOOLING
   */
  FASHION_WEEK = 'FASHION_WEEK',
  /**
   * @protobufOption (description) = "Retailer facing filters used to narrow down results across pages"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Filters"
   */
  FILTERS = 'FILTERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  FLASH_SALES = 'FLASH_SALES',
  /**
   * Replaced by more specific product areas (ALCOHOL, SAMPLES, etc)
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_FOOD_AND_BEVERAGE
   */
  FOOD_AND_BEVERAGE = 'FOOD_AND_BEVERAGE',
  /**
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   */
  FRONTEND_APIS = 'FRONTEND_APIS',
  /**
   * @protobufOption (description) = "Frontend tooling that doesn't have a more specific ProductArea"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Frontend Tooling"
   */
  FRONTEND_TOOLING = 'FRONTEND_TOOLING',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "FullStory recording"
   */
  FULLSTORY_CONFIG = 'FULLSTORY_CONFIG',
  /**
   * @protobufOption (pod) = FAIRE_POD_RELATIONSHIP_GROWTH
   */
  GMAIL = 'GMAIL',
  /**
   * @protobufOption (description) = "Goose is a service for managing sql migrations and queries. It is a replacement for Shift."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Goose"
   */
  GOOSE = 'GOOSE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  GUARANTEED_VOLUME = 'GUARANTEED_VOLUME',
  /**
   * @protobufOption (pod) = FAIRE_POD_UNASSIGNED
   */
  HACK_WEEK = 'HACK_WEEK',
  /**
   * @protobufOption (description) = "General FAQ/support resources"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Help Center"
   */
  HELP_CENTER = 'HELP_CENTER',
  /**
   * @deprecated
   * @protobufOption (description) = "Retailer homepage on web and home feed on mobile"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Home Feed"
   */
  HOME_FEED = 'HOME_FEED',
  /**
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Hot Jar Config"
   */
  HOT_JAR_CONFIG = 'HOT_JAR_CONFIG',
  /**
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Hotjar recording"
   */
  HOTJAR_CONFIG = 'HOTJAR_CONFIG',
  /**
   * @protobufOption (description) = "Backend infrastructure and tooling supporting translation requests"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Translation Infrastucture"
   */
  TRANSLATIONS = 'TRANSLATIONS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  HUBSPOT = 'HUBSPOT',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  IDV = 'IDV',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   */
  IMAGES = 'IMAGES',
  /**
   * @protobufOption (description) = "Intake of client analytics events."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Inalytics"
   */
  INALYTICS = 'INALYTICS',
  /**
   * @protobufOption (description) = "Faire offered incentives for retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Incentives"
   */
  INCENTIVES = 'INCENTIVES',
  /**
   * @protobufOption (description) = "AWS infrastructure, platform frameworks, and multi-region platform support."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Infrastructure"
   */
  INFRA = 'INFRA',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   */
  INFERENCE = 'INFERENCE',
  /**
   * @protobufOption (description) = "Faire's membership program offering benefits such as free shipping."
   * @protobufOption (pod) = FAIRE_POD_INSIDER
   * @protobufOption (title) = "Insider"
   */
  INSIDER = 'INSIDER',
  /**
   * @protobufOption (description) = "Payment instruments used to make payments."
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Instruments"
   */
  INSTRUMENTS = 'INSTRUMENTS',
  /**
   * @protobufOption (description) = "DEPRECATED: Use `INTERNAL_API_XXX` instead for specific features"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  INTERNAL_API = 'INTERNAL_API',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  INVENTORY = 'INVENTORY',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  ISSUE_REPORTS = 'ISSUE_REPORTS',
  /**
   * @protobufOption (description) = "Job producer and consumer core framework."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Job Framework"
   */
  JOBS = 'JOBS',
  /**
   * @protobufOption (description) = "All of our core components in one place."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Kitchen Sink"
   */
  KITCHEN_SINK = 'KITCHEN_SINK',
  /**
   * @protobufOption (description) = "A KG containing all the information we have on our retailers, brands, and products."
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Knowledge Graph"
   */
  KNOWLEDGE_GRAPH = 'KNOWLEDGE_GRAPH',
  /**
   * @deprecated
   * @protobufOption (description) = "Deprecated - use OPEN_WITH_FAIRE product area instead"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   */
  LAUNCH_WITH_FAIRE = 'LAUNCH_WITH_FAIRE',
  /**
   * @protobufOption (description) = "Triage product area used for PR bot to assign DD monitor latency tickets to correct pod."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "DD Monitor Latency Ticket to Pod Triage"
   */
  LATENCY_TRIAGE = 'LATENCY_TRIAGE',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Legal Documents"
   */
  LEGAL_DOCUMENTS = 'LEGAL_DOCUMENTS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Staging"
   */
  STAGING = 'STAGING',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_UPMARKET_TOOLING
   */
  LIVE_STREAMS = 'LIVE_STREAMS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   */
  LLM = 'LLM',
  /**
   * @protobufOption (description) = "Operations related to Large Language Models"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "LLM Operations"
   */
  LLM_OPERATIONS = 'LLM_OPERATIONS',
  /**
   * @protobufOption (description) = "Focus on translations, currencies, timezones, addresses."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Localization"
   */
  LOCALIZATION = 'LOCALIZATION',
  /**
   * @protobufOption (description) = "Area specific to homepage for logged-in retailers"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Logged-in Homepage"
   */
  LOGGED_IN_HOMEPAGE = 'LOGGED_IN_HOMEPAGE',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  MAKER_BUY_BACK = 'MAKER_BUY_BACK',
  /**
   * @protobufOption (pod) = FAIRE_POD_MARKETS_COORDINATION
   */
  MARKETS = 'MARKETS',
  /**
   * @protobufOption (description) = "User to user direct messaging."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Messenger"
   */
  MESSENGER = 'MESSENGER',
  /**
   * @protobufOption (description) = "Related to the additional information (e.g. profile, orders) that a user can see on Messenger."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Messenger Context Panel"
   */
  MESSENGER_CONTEXT_PANEL = 'MESSENGER_CONTEXT_PANEL',
  /**
   * @protobufOption (description) = "Inline contextual information displayed within messenger conversations"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Messenger Inline Context"
   */
  MESSENGER_INLINE_CONTEXT = 'MESSENGER_INLINE_CONTEXT',
  /**
   * @protobufOption (description) = "Fetching, saving, and removing milestones for user events"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Milestones"
   */
  MILESTONES = 'MILESTONES',
  /**
   * @protobufOption (description) = "Features that help identify and manage mispriced resellers on the Faire platform."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Mispriced Reseller"
   */
  MISPRICED_RESELLER = 'MISPRICED_RESELLER',
  /**
   * @deprecated
   * @protobufOption (description) = "The homepage on the retailer mobile apps, for logged in users"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Mobile Retailer Homepage Logged In"
   */
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN = 'MOBILE_RETAILER_HOMEPAGE_LOGGED_IN',
  /**
   * @protobufOption (description) = "The homepage on the retailer mobile apps, for logged out users"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Mobile Retailer Homepage Logged Out"
   */
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT = 'MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT',
  /**
   * @protobufOption (description) = "The logged out experience on the retailer mobile apps"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Mobile Retailer Logged Out Experience"
   */
  MOBILE_RETAILER_LOGGED_OUT = 'MOBILE_RETAILER_LOGGED_OUT',
  /**
   * @protobufOption (description) = "Messenger feature within the retailer mobile apps"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Mobile Retailer Messenger"
   */
  MOBILE_RETAILER_MESSENGER = 'MOBILE_RETAILER_MESSENGER',
  /**
   * @protobufOption (description) = "Onboarding experience in the retailer mobile apps"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Mobile Retailer Onboarding"
   */
  MOBILE_RETAILER_ONBOARDING = 'MOBILE_RETAILER_ONBOARDING',
  /**
   * @protobufOption (description) = "Signup experience in the retailer mobile apps"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Mobile Retailer Signup"
   */
  MOBILE_RETAILER_SIGNUP = 'MOBILE_RETAILER_SIGNUP',
  /**
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "My Brands"
   */
  MY_BRANDS = 'MY_BRANDS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Zendesk Translations"
   */
  ZENDESK_TRANSLATIONS = 'ZENDESK_TRANSLATIONS',
  /**
   * @protobufOption (description) = "Relational database persistence. Core infrastructure."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "MySQL"
   */
  MYSQL = 'MYSQL',
  /**
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT
   * @protobufOption (title) = "Infrastructure that powers the navigation experience"
   */
  NAVIGATION_INFRASTRUCTURE = 'NAVIGATION_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "How navigation nodes and category nodes (navigation tree) are displayed to users"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Navigation Tree UX"
   */
  NAVIGATION_TREE_UX = 'NAVIGATION_TREE_UX',
  /**
   * @protobufOption (description) = "Retailer terms management"
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Net Terms"
   */
  NET_TERMS = 'NET_TERMS',
  /**
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Newsroom"
   */
  NEWSROOM = 'NEWSROOM',
  /**
   * @protobufOption (description) = "Include pages like Amex and Square landing pages"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Partnerships Page"
   */
  PARTNERSHIPS_PAGE = 'PARTNERSHIPS_PAGE',
  /**
   * @protobufOption (description) = "Tool to search across many entities in the database https://www.faire.com/admin2"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Omnisearch"
   */
  OMNISEARCH = 'OMNISEARCH',
  /**
   * @protobufOption (description) = "Features related to the one.faire.team hub for connecting with your co-workers."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "One Faire Team"
   */
  ONE_FAIRE_TEAM = 'ONE_FAIRE_TEAM',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  OPEN_SIZING = 'OPEN_SIZING',
  /**
   * @protobufOption (description) = "Relates to Open With Faire features, for logged-in retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Open with Faire"
   */
  OPEN_WITH_FAIRE = 'OPEN_WITH_FAIRE',
  /**
   * @protobufOption (description) = "Relates to Open With Faire features, for logged-out retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Open with Faire - Logged-out"
   */
  OPEN_WITH_FAIRE_LOGGED_OUT = 'OPEN_WITH_FAIRE_LOGGED_OUT',
  /**
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  ORDER_SUBMISSION = 'ORDER_SUBMISSION',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  ORDERS = 'ORDERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  PACKING_SLIP = 'PACKING_SLIP',
  /**
   * @protobufOption (description) = "Payments from retailers and payments infrastructure."
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Payments"
   */
  PAYMENTS = 'PAYMENTS',
  /**
   * @protobufOption (description) = "Ensure international brands get first class experience viewing tax forms and commercial invoices."
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "PDF Rendering"
   */
  PDF_RENDERING = 'PDF_RENDERING',
  /**
   * @protobufOption (description) = "performance testing using dark reads."
   * @protobufOption (pod) = FAIRE_POD_MARKETS_COORDINATION
   * @protobufOption (title) = "Performance Dark Read"
   */
  PERF_DARK_READ = 'PERF_DARK_READ',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  PICK_LIST = 'PICK_LIST',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  PLAID = 'PLAID',
  /**
   * @protobufOption (pod) = FAIRE_POD_RELATIONSHIP_GROWTH
   */
  POSTMARK = 'POSTMARK',
  /**
   * @protobufOption (description) = "PR Bot NodeJS server, and Faire PR Bot GitHub App"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "PR Bot"
   */
  PR_BOT = 'PR_BOT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  PREORDERS = 'PREORDERS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  PREPACKS = 'PREPACKS',
  /**
   * @protobufOption (description) = "Work related to the prerelease environment"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Prerelease"
   */
  PRERELEASE = 'PRERELEASE',
  /**
   * @protobufOption (description) = "Brand acquisition landing page for Prestashop partnership"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Prestashop"
   */
  PRESTASHOP = 'PRESTASHOP',
  /**
   * Pricing has been split into Markets and Brand Pricing
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_PRICING
   */
  PRICING = 'PRICING',
  /**
   * @protobufOption (description) = "Features that help identify prices of products outside Faire, and enforcement of Faire's pricing policies."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Pricing Parity"
   */
  PRICING_PARITY = 'PRICING_PARITY',
  /**
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   */
  PRIVACY = 'PRIVACY',
  /**
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   */
  PRODUCERS = 'PRODUCERS',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   */
  PRODUCT_INFO = 'PRODUCT_INFO',
  /**
   * @protobufOption (description) = "Product price match guarantee feature"
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Product Price Match Guarantee"
   */
  PRODUCT_PRICE_MATCH_GUARANTEE = 'PRODUCT_PRICE_MATCH_GUARANTEE',
  /**
   * @protobufOption (description) = "Product reviews and ratings"
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Product Reviews"
   */
  PRODUCT_REVIEWS = 'PRODUCT_REVIEWS',
  /**
   * This version of samples was product specific, and was deleted in 2022
   * @deprecated
   * @protobufOption (description) = "Area for retailers to order samples for products. Deprecated, the new feature that is similar is SAMPLES"
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   * @protobufOption (title) = "Product Samples"
   */
  PRODUCT_SAMPLES = 'PRODUCT_SAMPLES',
  /**
   * @protobufOption (description) = "Tile representation of products used in retailer results such as product recommendation carousels, product first category results grid, product first search results grid."
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Product tiles"
   */
  PRODUCT_TILE = 'PRODUCT_TILE',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  PRODUCTS = 'PRODUCTS',
  /**
   * @protobufOption (description) = "APIs for managing products"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   */
  PRODUCTS_API = 'PRODUCTS_API',
  /**
   * @protobufOption (description) = "Infrastructure that handles product related replication between catalogs and monolith"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   */
  PRODUCTS_PLATFORM = 'PRODUCTS_PLATFORM',
  /**
   * @protobufOption (description) = "Modals for promotion"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Promo modals"
   */
  PROMO_MODALS = 'PROMO_MODALS',
  /**
   * @protobufOption (description) = "Events like Faire Summer Market or Faire Winter Market"
   * @protobufOption (pod) = FAIRE_POD_MARKETS_COORDINATION
   * @protobufOption (title) = "Promotional Events"
   */
  PROMOTIONAL_EVENTS = 'PROMOTIONAL_EVENTS',
  /**
   * @protobufOption (description) = "General infrastructure surrounding promotional codes to be used by retailers"
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   * @protobufOption (title) = "Promo codes for retailers"
   */
  PROMO_CODES = 'PROMO_CODES',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  /**
   * @protobufOption (description) = "Sending notification to mobile devices running Faire apps"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Push Notifications"
   */
  PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   */
  QUALTRICS = 'QUALTRICS',
  /**
   * @protobufOption (description) = "Lists of cases worked through by ops teams to complete various business objectives."
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Queues"
   */
  QUEUES = 'QUEUES',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  R2B_REFERRALS = 'R2B_REFERRALS',
  /**
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   */
  R2R_REFERRALS = 'R2R_REFERRALS',
  /**
   * @protobufOption (description) = "Search Ranking Algorithms"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_RANKING_ALGORITHMS
   * @protobufOption (title) = "Search Ranking"
   */
  RANKING = 'RANKING',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   */
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  /**
   * @protobufOption (description) = "Redis and ElasticCache core infrastructure."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Redis"
   */
  REDIS = 'REDIS',
  /**
   * @protobufOption (description) = "Internal tool for managing deployments."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Release Tool"
   */
  RELEASE_TOOL = 'RELEASE_TOOL',
  /**
   * @deprecated
   * @protobufOption (description) = "Regional search for retailers."
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Regional Search"
   */
  REGIONAL_SEARCH = 'REGIONAL_SEARCH',
  /**
   * @deprecated
   * @protobufOption (description) = "Area for retailers to see updates from previously ordered brands (AKA Retailer Brand Insights)"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Reorder Updates Hub"
   */
  REORDER_UPDATES_HUB = 'REORDER_UPDATES_HUB',
  /**
   * @protobufOption (description) = "Sending data to platforms for advertising purposes such as facebook."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Advertising to retailers"
   */
  RETAILER_ADVERTISING = 'RETAILER_ADVERTISING',
  /**
   * @deprecated
   * @protobufOption (description) = "Area for benefits given to Retailers when ordering from brands they're loyal to"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer Brand Loyalty"
   */
  RETAILER_BRAND_LOYALTY = 'RETAILER_BRAND_LOYALTY',
  /**
   * @protobufOption (description) = "Area for retailers to manager their relationships with brands"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Retailer Brands Management"
   */
  RETAILER_BRANDS_MANAGEMENT = 'RETAILER_BRANDS_MANAGEMENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   */
  RETAILER_FINDER_APP = 'RETAILER_FINDER_APP',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  RETAILER_INVOICES = 'RETAILER_INVOICES',
  /**
   * @protobufOption (description) = "Dynamic FE elements that allow BE to control frontend layout and content"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Retailer Layout Elements"
   */
  RETAILER_LAYOUT_ELEMENTS = 'RETAILER_LAYOUT_ELEMENTS',
  /**
   * @protobufOption (description) = "Service-specific infrastructure for layout service"
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM
   * @protobufOption (title) = "Layout Service"
   */
  LAYOUT_SERVICE = 'LAYOUT_SERVICE',
  /**
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   */
  RETAILER_MARKETING = 'RETAILER_MARKETING',
  /**
   * @protobufOption (pod) = FAIRE_POD_VALUE_MOBILE
   * @protobufOption (title) = "Faire Retailer App"
   */
  RETAILER_MOBILE = 'RETAILER_MOBILE',
  /**
   * @protobufOption (description) = "Sign up and post sign up experiences for new retailers."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Retailer Onboarding"
   */
  RETAILER_ONBOARDING = 'RETAILER_ONBOARDING',
  /**
   * @protobufOption (description) = "Area for retailers to manage their orders"
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   * @protobufOption (title) = "Retailer Order Management"
   */
  RETAILER_ORDER_MANAGEMENT = 'RETAILER_ORDER_MANAGEMENT',
  /**
   * @deprecated
   * @protobufOption (description) = "Transferring account ownership of a retailer from one user to another within the same retailer."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer owner transfer"
   */
  RETAILER_OWNER_TRANSFER = 'RETAILER_OWNER_TRANSFER',
  /**
   * Neighborhood is sunsetted.RETAILER_PORTAL
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   */
  RETAILER_PORTAL = 'RETAILER_PORTAL',
  /**
   * Now known as FAIRESYNC
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   */
  RETAILER_POS = 'RETAILER_POS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  RETAILER_REPORTING = 'RETAILER_REPORTING',
  /**
   * @protobufOption (description) = "Account preferences, payment methods, and store configuration options for retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer Settings Page"
   */
  RETAILER_SETTINGS_PAGE = 'RETAILER_SETTINGS_PAGE',
  /**
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Careers Page"
   */
  CAREERS_PAGE = 'CAREERS_PAGE',
  /**
   * @protobufOption (description) = "Unique lookback at a retailer's past year"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Retailer Year In Review"
   */
  RETAILER_YEAR_IN_REVIEW = 'RETAILER_YEAR_IN_REVIEW',
  /**
   * @deprecated
   * @protobufOption (description) = "Deprecated, use a more specific product area."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Retailers"
   */
  RETAILERS = 'RETAILERS',
  /**
   * @protobufOption (description) = "Looks into converting inactive retailers into active ordering ones"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Retailer Conversion"
   */
  RETAILER_CONVERSION = 'RETAILER_CONVERSION',
  /**
   * @protobufOption (description) = "Core retailer resources that cannot be assigned to a more specific product area"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   */
  RETAILER_CORE = 'RETAILER_CORE',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  RETURNS = 'RETURNS',
  /**
   * @protobufOption (description) = "Replay CockroachDB write back to MySQL"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Reverse Syncer"
   */
  REVERSE_SYNCER = 'REVERSE_SYNCER',
  /**
   * @deprecated
   * @protobufOption (description) = "Deprecated; use a more fine-grained RISK_* product area instead"
   * @protobufOption (pod) = FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS
   */
  RISK = 'RISK',
  /**
   * @protobufOption (description) = "Risk Ops tools"
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Risk Operations"
   */
  RISK_OPS = 'RISK_OPS',
  /**
   * @protobufOption (description) = "Data-driven risk assesment"
   * @protobufOption (pod) = FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "Risk Assessment"
   */
  RISK_ASSESSMENT = 'RISK_ASSESSMENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   */
  SALES_REPS = 'SALES_REPS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  SALESFORCE = 'SALESFORCE',
  /**
   * @protobufOption (description) = "Brand-facing samples. Built for Food and Beverage products and brands."
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Samples"
   */
  SAMPLES = 'SAMPLES',
  /**
   * @protobufOption (description) = "The retailer side of the sampling feature. Retailers request samples from brands. See also SAMPLES."
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Retailer-facing samples"
   */
  SAMPLES_RETAILER = 'SAMPLES_RETAILER',
  /**
   * @protobufOption (description) = "Spyglass is a tool for searching and analyzing user-facing comms across different channels"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "Spyglass"
   */
  SPYGLASS = 'SPYGLASS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Backend sandbox environments"
   */
  SANDBOX = 'SANDBOX',
  /**
   * @protobufOption (description) = "Retailer search results - layout in particular. This represents how search results are displayed to the user"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Search UX"
   */
  SEARCH = 'SEARCH',
  /**
   * @protobufOption (description) = "The suggested search queries that appear when a retailer types search requests"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   * @protobufOption (title) = "Search Suggestions"
   */
  SEARCH_SUGGESTIONS = 'SEARCH_SUGGESTIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT
   * @protobufOption (title) = "Search Infrastructure"
   */
  SEARCH_INFRASTRUCTURE = 'SEARCH_INFRASTRUCTURE',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Temporary catch-all product area for things owned by the Search Experience Accelerator Pod"
   */
  SEARCH_EXPERIENCE_ACCELERATOR = 'SEARCH_EXPERIENCE_ACCELERATOR',
  /**
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "See More page extension for existing layout elements"
   */
  SEE_MORE_PAGE = 'SEE_MORE_PAGE',
  /**
   * @deprecated
   * @protobufOption (description) = "Management (updating permission and subscription) of the multi users under a retailer"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer users management"
   */
  RETAILER_MULTI_USER_MANAGEMENT = 'RETAILER_MULTI_USER_MANAGEMENT',
  /**
   * @deprecated
   * @protobufOption (description) = "Sharing of shareable item with anonymous users via limited deep-links or established users via e-mail"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer team item sharing"
   */
  RETAILER_TEAM_SHARING = 'RETAILER_TEAM_SHARING',
  /**
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Seasonal Categories"
   */
  SEASONAL_CATEGORIES = 'SEASONAL_CATEGORIES',
  /**
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Impersonation"
   */
  IMPERSONATION = 'IMPERSONATION',
  /**
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   */
  SECURITY = 'SECURITY',
  /**
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   */
  SENTRY = 'SENTRY',
  /**
   * @protobufOption (description) = "Pages/features introduced to drive up our SEO (Search Engine Optimization)."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "SEO"
   */
  SEO = 'SEO',
  /**
   * @protobufOption (description) = "User session management."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Session"
   */
  SESSIONS = 'SESSIONS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   */
  SETTINGS = 'SETTINGS',
  /**
   * @deprecated
   * @protobufOption (description) = "DEPRECATED: Replaced by SHIPPING product area for shipping functionality."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   */
  SHIPMENTS = 'SHIPMENTS',
  /**
   * @protobufOption (description) = "Shipping of products."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Shipping"
   */
  SHIPPING = 'SHIPPING',
  /**
   * @protobufOption (description) = "Management of addresses"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Addresses"
   */
  ADDRESSES = 'ADDRESSES',
  /**
   * @protobufOption (description) = "Insurance for shipped items"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Shipping Insurance"
   */
  SHIPPING_INSURANCE = 'SHIPPING_INSURANCE',
  /**
   * @protobufOption (description) = "Handling of commercial invoices"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Commercial Invoices"
   */
  COMMERCIAL_INVOICES = 'COMMERCIAL_INVOICES',
  /**
   * @protobufOption (description) = "Management of tariff codes"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Tariff Codes"
   */
  TARIFF_CODES = 'TARIFF_CODES',
  /**
   * @protobufOption (description) = "Integration with Sapient for Royalmail tracking"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Sapient tracking integration"
   */
  SAPIENT = 'SAPIENT',
  /**
   * Shopify Makers has been shut down and deleted
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  SHOPIFY_MAKERS = 'SHOPIFY_MAKERS',
  /**
   * @protobufOption (description) = "faire.com signin"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Signin"
   */
  SIGNIN = 'SIGNIN',
  /**
   * @deprecated
   * @protobufOption (description) = "faire.com signup"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Signup"
   */
  SIGNUP = 'SIGNUP',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   */
  SLACK = 'SLACK',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   */
  SLATE_DESIGN_SYSTEM = 'SLATE_DESIGN_SYSTEM',
  /**
   * @protobufOption (pod) = FAIRE_POD_SLATE_DESIGN_SYSTEM
   * @protobufOption (title) = "Slate Core Components Library"
   */
  SLATE_CORE_COMPONENTS_LIBRARY = 'SLATE_CORE_COMPONENTS_LIBRARY',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_UNASSIGNED
   * @protobufOption (title) = "Brand Components Library"
   */
  BRAND_COMPONENTS_LIBRARY = 'BRAND_COMPONENTS_LIBRARY',
  /**
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM
   * @protobufOption (title) = "Retailer Components Library"
   */
  RETAILER_COMPONENTS_LIBRARY = 'RETAILER_COMPONENTS_LIBRARY',
  /**
   * @protobufOption (pod) = FAIRE_POD_SLATE_DESIGN_SYSTEM
   * @protobufOption (title) = "Slate Foundations Library"
   */
  SLATE_FOUNDATIONS_LIBRARY = 'SLATE_FOUNDATIONS_LIBRARY',
  /**
   * @protobufOption (description) = "Tools relating to Slate"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Slate Tools"
   */
  SLATE_TOOLS = 'SLATE_TOOLS',
  /**
   * @protobufOption (pod) = FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL
   * @protobufOption (title) = "Search Query Understanding and Retrieval Algorithm"
   */
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL = 'SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  STRIPE = 'STRIPE',
  /**
   * @protobufOption (description) = "Integration with Sunshine Conversations for the Help Center"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "SunCo chat integration"
   */
  SUNCO = 'SUNCO',
  /**
   * @protobufOption (description) = "https://www.notion.so/faire/Swatches-f049024297c046c8aa122bc25c8214fc"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Swatches"
   */
  SWATCHES = 'SWATCHES',
  /**
   * @protobufOption (description) = "Websocket management."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Switchboard"
   */
  SWITCHBOARD = 'SWITCHBOARD',
  /**
   * @protobufOption (description) = "Integration with 3rd party service Taktile"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Taktile"
   */
  TAKTILE = 'TAKTILE',
  /**
   * @protobufOption (description) = "Scheduled task execution core framework."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Task"
   */
  TASKS = 'TASKS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM_COMPLIANCE
   * @protobufOption (title) = "Tax Forms for brands"
   */
  TAX_FORMS = 'TAX_FORMS',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM_COMPLIANCE
   */
  TAXES = 'TAXES',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  TAXONOMY = 'TAXONOMY',
  /**
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   */
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
  /**
   * @protobufOption (pod) = FAIRE_POD_UNASSIGNED
   */
  TEST = 'TEST',
  /**
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   */
  TESTIMONIALS = 'TESTIMONIALS',
  /**
   * @protobufOption (description) = "Tool to view changes in a database entity over time https://www.faire.com/admin2/records/time-turner"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Time Turner"
   */
  TIME_TURNER = 'TIME_TURNER',
  /**
   * @protobufOption (description) = "Rewarding brands for great service with a Top Shop badge. Brands can earn Top Shop status by maintaining high ratings, low return rates, and excellent customer service."
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Top Shop"
   */
  TOP_BRAND = 'TOP_BRAND',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  TRADESHOW = 'TRADESHOW',
  /**
   * @protobufOption (description) = "Form for employees to submit feedback on internal tools"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Universal Feedback Tool"
   */
  UNIVERSAL_FEEDBACK_TOOL = 'UNIVERSAL_FEEDBACK_TOOL',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_UPMARKET_TOOLING
   */
  UPMARKET = 'UPMARKET',
  /**
   * @deprecated
   * @protobufOption (pod) = FAIRE_POD_UPMARKET_EXPERIENCE
   */
  UPMARKET_EXPERIENCE = 'UPMARKET_EXPERIENCE',
  /**
   * @deprecated
   * @protobufOption (description) = "Feature for retailer admin to invite multiple users to the retailer"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "User invitation"
   */
  USER_INVITATION = 'USER_INVITATION',
  /**
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   */
  USERS = 'USERS',
  /**
   * @protobufOption (description) = "Validation framework for enforcing data integrity and constraints"
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Validation"
   */
  VALIDATION = 'VALIDATION',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  VIDEOS = 'VIDEOS',
  /**
   * web-visitor is discontinued
   * @deprecated
   * @protobufOption (description) = "General fallback for features pertaining to the web-visitor React App."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "web-visitor React App"
   */
  VISITORS = 'VISITORS',
  /**
   * @protobufOption (description) = "The Faire VS Code Extension"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "VS Code Extension"
   */
  VS_CODE_EXTENSION = 'VS_CODE_EXTENSION',
  /**
   * @protobufOption (description) = "Allows retailers in countries where we haven't launched to record their interest in joining Faire"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Waitlisted signup"
   */
  WAITLISTED_SIGNUP = 'WAITLISTED_SIGNUP',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  WAREHOUSE_TOOLING = 'WAREHOUSE_TOOLING',
  /**
   * @protobufOption (description) = "Faire Web Docs site for all frontend and slate documentation"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Web Docs Site"
   */
  WEB_DOCS_SITE = 'WEB_DOCS_SITE',
  /**
   * @deprecated
   * @protobufOption (description) = "Node.js server for web-retailer. DEPRECATED: Migrating to Next.js infrastructure."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Web Retailer Server"
   */
  WEB_RETAILER_SERVER = 'WEB_RETAILER_SERVER',
  /**
   * @deprecated
   * @protobufOption (description) = "Server-side rendering for web front-end. DEPRECATED: Migrating to Next.js infrastructure."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Server-side rendering"
   */
  WEB_SERVER_SIDE_RENDERING = 'WEB_SERVER_SIDE_RENDERING',
  /**
   * @protobufOption (description) = "Web server core infrastructure and framework."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Web Server"
   */
  WEBSERVER = 'WEBSERVER',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  XLSX_IMPORT = 'XLSX_IMPORT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   */
  XLSX_ONBOARDING_IMPORT = 'XLSX_ONBOARDING_IMPORT',
  /**
   * @deprecated
   * @protobufOption (description) = "DEPRECATED: Geographic exclusivity protection system, replaced by EXCLUSIVITY product area"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   */
  ZIP_CODE_PROTECTION = 'ZIP_CODE_PROTECTION',
  /**
   * @protobufOption (description) = "Teams Page, checkout review and collaborator tracking on cart, orders, etc."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   */
  RETAILER_TEAM_MANAGEMENT = 'RETAILER_TEAM_MANAGEMENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   */
  BRAND_INCREMENTALITY = 'BRAND_INCREMENTALITY',
  /**
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   */
  ZENDESK = 'ZENDESK',
  /**
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   */
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE = 'MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "Retailer-facing functionality for serving marketplace ads, a.k.a. Paid Placement or Promoted Listings"
   * @protobufOption (pod) = FAIRE_POD_ADS_DELIVERY
   */
  ADS = 'ADS',
  /**
   * @protobufOption (description) = "Brand experience for managing marketplace ads"
   * @protobufOption (pod) = FAIRE_POD_ADS_MANAGER
   */
  ADS_MANAGER = 'ADS_MANAGER',
  /**
   * @protobufOption (description) = "Filters and merchandising to increase local supply in Europe"
   * @protobufOption (pod) = FAIRE_POD_SEARCH_UX
   */
  LOCAL_FILTERS_AND_MERCHANDISING = 'LOCAL_FILTERS_AND_MERCHANDISING',
  /**
   * @deprecated
   * @protobufOption (description) = "Relate to Recognizable Brands model usage"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Recognizable Brands"
   */
  RECOGNIZABLE_BRANDS = 'RECOGNIZABLE_BRANDS',
  /**
   * @protobufOption (description) = "Logged out retailer experience"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Logged Out Retailers"
   */
  LOGGED_OUT_RETAILERS = 'LOGGED_OUT_RETAILERS',
  /**
   * @protobufOption (description) = "Node.js server for brand-portal"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM_COMPLIANCE
   * @protobufOption (title) = "Web Brand Server"
   */
  WEB_BRAND_SERVER = 'WEB_BRAND_SERVER',
  /**
   * @protobufOption (description) = "NextJS infrastructure and routing for brand-portal"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM_COMPLIANCE
   * @protobufOption (title) = "Web Brand NextJS"
   */
  WEB_BRAND_NEXTJS = 'WEB_BRAND_NEXTJS',
  /**
   * @protobufOption (description) = "Financial Events"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Financial Events"
   */
  FINANCIAL_EVENTS = 'FINANCIAL_EVENTS',
  /**
   * @protobufOption (description) = "Web Proxy service"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Web Proxy service"
   */
  WEB_PROXY = 'WEB_PROXY',
  /**
   * @protobufOption (description) = "Related to keeping the retailer's profile information up to date"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer Profile Info"
   */
  RETAILER_PROFILE_INFO = 'RETAILER_PROFILE_INFO',
  /**
   * @protobufOption (description) = "Related to retailer restrictions to prevent certain products from being shipped to certain countries (e.g, can't ship cosmetics to Spain)"
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Retailer Shipping Restriction"
   */
  SHIPPING_RESTRICTION = 'SHIPPING_RESTRICTION',
  /**
   * @protobufOption (description) = "Related to the infrastructure that powers Faire's recommendations"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Recommendations Infrastructure"
   */
  RECOMMENDATIONS_INFRASTRUCTURE = 'RECOMMENDATIONS_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "Related to the general process of recommendation at Faire, across all discovery surfaces"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Discovery Recommendations"
   */
  DISCOVERY_RECOMMENDATIONS = 'DISCOVERY_RECOMMENDATIONS',
  /**
   * @protobufOption (description) = "Area specific to brand page for retailers"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Brand page"
   */
  BRAND_PAGE = 'BRAND_PAGE',
  /**
   * @protobufOption (description) = "Area specific to product page for retailers"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Product page"
   */
  PRODUCT_PAGE = 'PRODUCT_PAGE',
  /**
   * @protobufOption (description) = "Integration with Fonoa for business identifier validations"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM_COMPLIANCE
   * @protobufOption (title) = "Fonoa third-party vendor integration"
   */
  FONOA = 'FONOA',
  /**
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile Core Infrastructure"
   */
  MOBILE_CORE = 'MOBILE_CORE',
  /**
   * @protobufOption (description) = "Features related to managing multiple stores within a retailer."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Retailer store management"
   */
  RETAILER_STORE_MANAGEMENT = 'RETAILER_STORE_MANAGEMENT',
  /**
   * @protobufOption (description) = "Features related to manage commission update requests from the brand"
   * @protobufOption (pod) = FAIRE_POD_FAIRE_DIRECT_GROWTH
   * @protobufOption (title) = "Commission update requests"
   */
  COMMISSION_UPDATE_REQUESTS = 'COMMISSION_UPDATE_REQUESTS',
  /**
   * @protobufOption (description) = "Features related Scim integrations with Okta."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "SCIM User Management"
   */
  SCIM = 'SCIM',
  /**
   * @protobufOption (description) = "Internal API support for Salesforce"
   * @protobufOption (pod) = FAIRE_POD_BRAND_ACQUISITION
   * @protobufOption (title) = "Internal API support for Salesforce"
   */
  INTERNAL_API_SALESFORCE = 'INTERNAL_API_SALESFORCE',
  /**
   * @protobufOption (description) = "Internal API support for Catalogs Migration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Internal API support for Catalogs Migration"
   */
  INTERNAL_API_CATALOGS_MIGRATION = 'INTERNAL_API_CATALOGS_MIGRATION',
  /**
   * @protobufOption (description) = "Internal API support for the embedded Retailer Shopify App"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Internal API support for the embedded Retailer Shopify App"
   */
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION = 'INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION',
  /**
   * @protobufOption (description) = "Internal API support for Inventory"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Internal API support for Inventory"
   */
  INTERNAL_API_INVENTORY = 'INTERNAL_API_INVENTORY',
  /**
   * @protobufOption (description) = "Internal API support for orders"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Internal API support for orders"
   */
  INTERNAL_API_ORDERS = 'INTERNAL_API_ORDERS',
  /**
   * @protobufOption (description) = "Faire for teams is a feature that allows brands to manage multiple users within their organization."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Faire for Teams"
   */
  FAIRE_FOR_TEAMS = 'FAIRE_FOR_TEAMS',
  /**
   * @protobufOption (description) = "Allows users to manage multiple brands."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Multi Brand"
   */
  MULTI_BRAND = 'MULTI_BRAND',
  /**
   * @protobufOption (description) = "Alert banners for brands"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Alert Banners Brand"
   */
  ALERT_BANNERS_BRAND = 'ALERT_BANNERS_BRAND',
  /**
   * @protobufOption (description) = "Alert banners for retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Alert Banners Retailer"
   */
  ALERT_BANNERS_RETAILERS = 'ALERT_BANNERS_RETAILERS',
  /**
   * @protobufOption (description) = "Clawback for brands"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Clawback for brands"
   */
  ISSUE_REPORT_CLAWBACKS = 'ISSUE_REPORT_CLAWBACKS',
  /**
   * @protobufOption (description) = "Clawback for retailers"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Clawback for retailers"
   */
  RETURN_CLAWBACKS = 'RETURN_CLAWBACKS',
  /**
   * @protobufOption (description) = "Canonical Data Model & ETLs"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Canonical Data Model & ETLs"
   */
  CANONICAL_DATA = 'CANONICAL_DATA',
  /**
   * @protobufOption (description) = "Financial Data Platform"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Financial Data Platform"
   */
  FINACIAL_DATA_PLATFORM = 'FINACIAL_DATA_PLATFORM',
  /**
   * @protobufOption (description) = "Data Security & Compliance"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Security & Compliance"
   */
  DATA_SECURITY = 'DATA_SECURITY',
  /**
   * @protobufOption (description) = "Data Warehouse (Snowflake)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Snowflake"
   */
  DATA_WAREHOUSE = 'DATA_WAREHOUSE',
  /**
   * @protobufOption (description) = "Data Workflow Management (Airflow)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Airflow"
   */
  DATA_AIRFLOW = 'DATA_AIRFLOW',
  /**
   * @protobufOption (description) = "Data Movement (Fivetran)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Fivetran"
   */
  DATA_FIVETRAN = 'DATA_FIVETRAN',
  /**
   * @protobufOption (description) = "Data Reporting (Looker)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Looker"
   */
  DATA_LOOKER = 'DATA_LOOKER',
  /**
   * @protobufOption (description) = "Data Reporting (Mode)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Mode"
   */
  DATA_MODE = 'DATA_MODE',
  /**
   * @protobufOption (description) = "SelectStar"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "SelectStar"
   */
  DATA_SELECTSTAR = 'DATA_SELECTSTAR',
  /**
   * @protobufOption (description) = "data.faire.com"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "data.faire.com"
   */
  DATA_FAIRE_COM = 'DATA_FAIRE_COM',
  /**
   * @protobufOption (description) = "Data Mesh"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Mesh"
   */
  DATA_MESH = 'DATA_MESH',
  /**
   * @protobufOption (description) = "Data Environments (Staging, Pre-release, PROD)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Environments (Staging, Pre-release, PROD)"
   */
  DATA_ENV = 'DATA_ENV',
  /**
   * @protobufOption (description) = "Stream Processing (Ververica, Flink)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Stream Processing (Ververica, Flink)"
   */
  STREAM_PROCESSING = 'STREAM_PROCESSING',
  /**
   * @protobufOption (description) = "Data AWS (S3, EC2, etc.)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data AWS (S3, EC2, etc.)"
   */
  DATA_AWS = 'DATA_AWS',
  /**
   * @protobufOption (description) = "Data Contracts"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Data Contracts"
   */
  DATA_CONTRACTS = 'DATA_CONTRACTS',
  /**
   * @protobufOption (description) = "Retailer Universe"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Retailer Universe"
   */
  RETAILER_UNIVERSE = 'RETAILER_UNIVERSE',
  /**
   * @protobufOption (description) = "External Data Integration (web crawlers, 3rd party APIs)"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "KG Scraping"
   */
  KG_SCRAPE = 'KG_SCRAPE',
  /**
   * @protobufOption (description) = "NLP & Image-based Entity Matching"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "KG Matching"
   */
  KG_MATCH = 'KG_MATCH',
  /**
   * @deprecated
   * @protobufOption (description) = "Experiment Metrics"
   * @protobufOption (pod) = FAIRE_POD_CORE_DATA_INFRA
   * @protobufOption (title) = "Experiment Metrics"
   */
  XP_METRICS = 'XP_METRICS',
  /**
   * @protobufOption (description) = "Feature Store & DSL"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Feature Store & DSL"
   */
  FEATURE_STORE = 'FEATURE_STORE',
  /**
   * @protobufOption (description) = "Model Store (CometML)"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Model Store (CometML)"
   */
  MODEL_STORE = 'MODEL_STORE',
  /**
   * @protobufOption (description) = "ML Inference Service"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Inference Service"
   */
  INFERENCE_SERVICE = 'INFERENCE_SERVICE',
  /**
   * @protobufOption (description) = "ML Observability"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "ML Observability"
   */
  ML_OBSERVABILITY = 'ML_OBSERVABILITY',
  /**
   * @protobufOption (description) = "Observability"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Observability"
   */
  OBSERVABILITY = 'OBSERVABILITY',
  /**
   * @deprecated
   * @protobufOption (description) = "Oracle Cloud GPU Cluster"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Oracle Cloud GPU Cluster"
   */
  ORACLE_CLOUD = 'ORACLE_CLOUD',
  /**
   * @protobufOption (description) = "Oracle Cloud GPU Cluster Infra"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Oracle Cloud GPU Cluster Infra"
   */
  OCI_GPU_CLUSTER_INFRA = 'OCI_GPU_CLUSTER_INFRA',
  /**
   * @protobufOption (description) = "ML Model Training Framework"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "ML Model Training Framework"
   */
  ML_TRAINING = 'ML_TRAINING',
  /**
   * @protobufOption (description) = "Internal API support for Products"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Internal API support for Products"
   */
  INTERNAL_API_PRODUCTS = 'INTERNAL_API_PRODUCTS',
  /**
   * @protobufOption (description) = "Internal API support for Images"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Internal API support for Images"
   */
  INTERNAL_API_IMAGES = 'INTERNAL_API_IMAGES',
  /**
   * @protobufOption (description) = "Common test utilities for backend services"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Backend Test Infra"
   */
  BACKEND_TEST_INFRA = 'BACKEND_TEST_INFRA',
  /**
   * @protobufOption (description) = "Service-specific infrastructure for catalogs service"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Catalogs Service"
   */
  CATALOGS_SERVICE = 'CATALOGS_SERVICE',
  /**
   * @protobufOption (description) = "Brand Terms of Service"
   * @protobufOption (pod) = FAIRE_POD_BRAND_PLATFORM
   * @protobufOption (title) = "Brand Terms of Service"
   */
  BRAND_TERMS_OF_SERVICE = 'BRAND_TERMS_OF_SERVICE',
  /**
   * @protobufOption (description) = "Retailer Notifications"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Retailer Notifications"
   */
  RETAILER_NOTIFICATIONS = 'RETAILER_NOTIFICATIONS',
  /**
   * @protobufOption (description) = "Mobile Phoenix architecture infrastructure"
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile Phoenix Architecture"
   */
  PHOENIX = 'PHOENIX',
  /**
   * @protobufOption (description) = "Build and CI infrastructure for mobile"
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile Build Infrastructure"
   */
  MOBILE_APP_BUILD_INFRASTRUCTURE = 'MOBILE_APP_BUILD_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "Settings and experiment infrastructure for mobile"
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile App Settings"
   */
  MOBILE_APP_SETTINGS = 'MOBILE_APP_SETTINGS',
  /**
   * @protobufOption (description) = "Mobile app launch and initialization processes"
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile App Startup"
   */
  MOBILE_APP_STARTUP = 'MOBILE_APP_STARTUP',
  /**
   * @protobufOption (description) = "Product messaging platform"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Product Messaging"
   */
  PRODUCT_MESSAGING = 'PRODUCT_MESSAGING',
  /**
   * @protobufOption (description) = "Personalization"
   * @protobufOption (pod) = FAIRE_POD_PERSONALIZATION
   * @protobufOption (title) = "Personalization"
   */
  PERSONALIZATION = 'PERSONALIZATION',
  /**
   * @protobufOption (description) = "Tool to arrange products in the brand portal and then show them in the retailer portal in that order"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Custom Arrangement"
   */
  CUSTOM_ARRANGEMENT = 'CUSTOM_ARRANGEMENT',
  /**
   * @protobufOption (description) = "Integration with third-party vendor Runway, our mobile release tooling"
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Runway Client"
   */
  RUNWAY = 'RUNWAY',
  /**
   * @deprecated
   * @protobufOption (description) = "Conversational Search aims to use LLMs to provide guided shopping assistance to users."
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT
   * @protobufOption (title) = "Conversational Search"
   */
  CONVERSATIONAL_SEARCH = 'CONVERSATIONAL_SEARCH',
  /**
   * @protobufOption (description) = "Managing addresses for retailers; EG: CRUD operations as well as managing associations with other entities."
   * @protobufOption (pod) = FAIRE_POD_SHIPPING
   * @protobufOption (title) = "Retailer Address Management"
   */
  RETAILER_ADDRESS_MANAGEMENT = 'RETAILER_ADDRESS_MANAGEMENT',
  /**
   * @protobufOption (description) = "Handling backorders on retailer side."
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   * @protobufOption (title) = "Retailer Backorders"
   */
  RETAILER_BACKORDERS = 'RETAILER_BACKORDERS',
  /**
   * @protobufOption (description) = "A personalized page with recommendations for each retailer."
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "The Digest or 'Weekly Drop' Page"
   */
  DIGEST_PAGE = 'DIGEST_PAGE',
  /**
   * @protobufOption (description) = "Moving page data returned from HomeResourceTemplateBuilder to page APIs."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Page data APIs"
   */
  PAGE_DATA_APIS = 'PAGE_DATA_APIS',
  /**
   * @protobufOption (description) = "Mobile CI Projects Infrastructure."
   * @protobufOption (pod) = FAIRE_POD_MOBILE_PLATFORM
   * @protobufOption (title) = "Mobile CI"
   */
  MOBILE_CI = 'MOBILE_CI',
  /**
   * @protobufOption (description) = "Framework for asynchronous csv exports"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   */
  CSV_EXPORT = 'CSV_EXPORT',
  /**
   * @protobufOption (description) = "Integrations and support for external Marketing platforms like Meta and Google"
   * @protobufOption (pod) = FAIRE_POD_GROWTH_PLATFORM
   * @protobufOption (title) = "MarTech"
   */
  PAID_MARKETING = 'PAID_MARKETING',
  /**
   * @protobufOption (description) = "Brand specific messaging"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand Messenger"
   */
  BRAND_MESSENGER = 'BRAND_MESSENGER',
  /**
   * @protobufOption (description) = "Retailer specific messaging"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Retailer Messenger"
   */
  RETAILER_MESSENGER = 'RETAILER_MESSENGER',
  /**
   * @protobufOption (description) = "Related to the infrastructure that powers Faire's messaging"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "messenger infrastructure"
   */
  MESSENGER_INFRASTRUCTURE = 'MESSENGER_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "Retailer authorization for the Activation team (for example, credit check authorization)"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Retailer Authorization"
   */
  RETAILER_AUTHORIZATION = 'RETAILER_AUTHORIZATION',
  /**
   * @protobufOption (description) = "Shop Local app"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Shop Local"
   */
  SHOP_LOCAL = 'SHOP_LOCAL',
  /**
   * @protobufOption (description) = "Configuring backend applications with ConfigVars and SecretConfigVars"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Config Vars"
   */
  CONFIG_VARS = 'CONFIG_VARS',
  /**
   * @protobufOption (description) = "Caching data to improve performance and reduce load on downstream components"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS
   * @protobufOption (title) = "Caching"
   */
  CACHING = 'CACHING',
  /**
   * @protobufOption (description) = "The side cart experience, used on brand and PDP pages to show the items currently in cart"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Side Cart"
   */
  SIDE_CART = 'SIDE_CART',
  /**
   * @protobufOption (description) = "Retailer requests unlisted products from Brands functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Unlisted Products"
   */
  UNLISTED_PRODUCTS = 'UNLISTED_PRODUCTS',
  /**
   * @protobufOption (description) = "The Faire Pay payment method ands its associated tools."
   * @protobufOption (pod) = FAIRE_POD_FAIRE_PAY
   * @protobufOption (title) = "Faire Pay"
   */
  FAIRE_PAY = 'FAIRE_PAY',
  /**
   * @protobufOption (description) = "Faire-run Fulfillment for Brands"
   * @protobufOption (pod) = FAIRE_POD_FULFILLED_BY_FAIRE
   * @protobufOption (title) = "Fulfilled by Faire"
   */
  FULFILLED_BY_FAIRE = 'FULFILLED_BY_FAIRE',
  /**
   * @protobufOption (description) = "Service-specific infrastructure for home-retailer service"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Home retailer Service"
   */
  HOME_RETAILER_SERVICE = 'HOME_RETAILER_SERVICE',
  /**
   * @protobufOption (description) = "Admin server for providing Admin2 release info"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Admin Server"
   */
  ADMIN_SERVER = 'ADMIN_SERVER',
  /**
   * @protobufOption (description) = "Pete server for providing pete event server release info"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Pete Server"
   */
  PETE_SERVER = 'PETE_SERVER',
  /**
   * @protobufOption (description) = "Volume Based Discounts provides savings based on purchase volume"
   * @protobufOption (pod) = FAIRE_POD_INSIDER
   * @protobufOption (title) = "Volume Based Discounts"
   */
  VOLUME_BASED_DISCOUNTS = 'VOLUME_BASED_DISCOUNTS',
  /**
   * @protobufOption (description) = "Continuous Integration/Deployment"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "CI/CD"
   */
  CI_CD = 'CI_CD',
  /**
   * @protobufOption (description) = "Retailer-facing product bundle recommendations"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Product Bundles"
   */
  PRODUCT_BUNDLES = 'PRODUCT_BUNDLES',
  /**
   * @protobufOption (description) = "Generic customer feedback consisting of a single text field"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Customer Feedback"
   */
  CUSTOMER_FEEDBACK = 'CUSTOMER_FEEDBACK',
  /**
   * @protobufOption (description) = "The internal Mission Control tool: https://dev.faire.team/tools/mission-control"
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   * @protobufOption (title) = "Mission Control"
   */
  MISSION_CONTROL = 'MISSION_CONTROL',
  /**
   * @protobufOption (description) = "External logger companion tool for mobile"
   * @protobufOption (pod) = FAIRE_POD_VALUE_MOBILE
   * @protobufOption (title) = "Mobile Wardrobe"
   */
  MOBILE_WARDROBE = 'MOBILE_WARDROBE',
  /**
   * @protobufOption (description) = "Login via SSO"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Single Sign On (SSO)"
   */
  SINGLE_SIGN_ON = 'SINGLE_SIGN_ON',
  /**
   * @protobufOption (description) = "Shopping assistant in the mobile retailer apps"
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM
   * @protobufOption (title) = "Shopping Assistant"
   */
  SHOPPING_ASSISTANT = 'SHOPPING_ASSISTANT',
  /**
   * @protobufOption (description) = "Faire's internal server-driven UI framework"
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM
   * @protobufOption (title) = "SDUI (Server-Driven UI)"
   */
  SDUI = 'SDUI',
  /**
   * @protobufOption (description) = "Integration with the Eppo experimentation platform https://docs.geteppo.com/"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Eppo"
   */
  EPPO = 'EPPO',
  /**
   * @protobufOption (description) = "Visitor app code in frontend repo that's responsible for logged-out web pages"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Visitor App"
   */
  VISITOR_APP = 'VISITOR_APP',
  /**
   * @protobufOption (description) = "Visitor server code in frontend repo that's responsible for logged-out web pages"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Visitor Server"
   */
  VISITOR_SERVER = 'VISITOR_SERVER',
  /**
   * @protobufOption (pod) = FAIRE_POD_EVALUATE
   */
  PURCHASE_ORDER_INGESTION = 'PURCHASE_ORDER_INGESTION',
  /**
   * @protobufOption (description) = "NextJS infrastructure and routing for help center"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Help Center NextJS"
   */
  HELP_CENTER_NEXT_JS = 'HELP_CENTER_NEXT_JS',
  /**
   * @protobufOption (description) = "Impression logging engineering infrastructure for backend and viewport impressions"
   * @protobufOption (pod) = FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM
   * @protobufOption (title) = "Impression Logging"
   */
  IMPRESSION_LOGGING = 'IMPRESSION_LOGGING',
  /**
   * @protobufOption (description) = "Retailer awareness of brands on Faire already integrated with their POS"
   * @protobufOption (pod) = FAIRE_POD_ONE_STOP_SHOP
   * @protobufOption (title) = "Retailer Brand Consolidation"
   */
  RETAILER_BRAND_CONSOLIDATION = 'RETAILER_BRAND_CONSOLIDATION',
  /**
   * @protobufOption (description) = "Integration with Pinecone for vector database"
   * @protobufOption (pod) = FAIRE_POD_AI_PLATFORM
   * @protobufOption (title) = "Pinecone"
   */
  PINECONE = 'PINECONE',
  /**
   * @protobufOption (description) = "Service-specific infrastructure for brands service"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Brands Service"
   */
  BRANDS_SERVICE = 'BRANDS_SERVICE',
  /**
   * @protobufOption (description) = "Service-specific infrastructure for brands service migration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Brands Service Migration"
   */
  BRANDS_SERVICE_MIGRATION = 'BRANDS_SERVICE_MIGRATION',
  /**
   * @protobufOption (description) = "Relevant to cart and checkout improvement that we want to do to activate retailers"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Cart Checkout Improvement"
   */
  CART_CHECKOUT_IMPROVEMENT = 'CART_CHECKOUT_IMPROVEMENT',
  /**
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   */
  PRODUCT_LISTING_QUALITY = 'PRODUCT_LISTING_QUALITY',
  /**
   * @protobufOption (description) = "Delisting brand products due to terms of service violations"
   * @protobufOption (pod) = FAIRE_POD_MARKETPLACE_QUALITY
   * @protobufOption (title) = "Product Delisting"
   */
  PRODUCT_DELISTING = 'PRODUCT_DELISTING',
  /**
   * @protobufOption (description) = "Service extraction of orders-related functionality from monolith"
   * @protobufOption (pod) = FAIRE_POD_ORDERS_MIGRATION
   * @protobufOption (title) = "Orders service migration"
   */
  ORDERS_MIGRATION = 'ORDERS_MIGRATION',
  /**
   * @protobufOption (description) = "Account and User Management"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @protobufOption (title) = "Retailer Account Management"
   */
  RETAILER_ACCOUNT_MANAGEMENT = 'RETAILER_ACCOUNT_MANAGEMENT',
  /**
   * @protobufOption (description) = "System for signing identifiers against session information to prevent IDOR leaks."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Owned Tokens"
   */
  OWNED_TOKENS = 'OWNED_TOKENS',
  /**
   * @protobufOption (description) = "Area for retailers to see updates from followed brands (AKA Retailer Brand Insights)"
   * @protobufOption (pod) = FAIRE_POD_INSPIRE
   * @protobufOption (title) = "Insights Updates Hub"
   */
  INSIGHTS_UPDATES_HUB = 'INSIGHTS_UPDATES_HUB',
  /**
   * @protobufOption (description) = "Importing a brand's catalog from their personal website using web scraping"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Web Bridge"
   */
  WEB_BRIDGE = 'WEB_BRIDGE',
  /**
   * @protobufOption (description) = "Admin tools for brand shopify integration"
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Brand Shopify Admin"
   */
  BRAND_SHOPIFY_ADMIN = 'BRAND_SHOPIFY_ADMIN',
  /**
   * @protobufOption (description) = "Virtual assistant tools and infrastructure for Help Center customer support and operations"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Virtual Assistant"
   */
  VIRTUAL_ASSISTANT = 'VIRTUAL_ASSISTANT',
  /**
   * @protobufOption (description) = "Infrastructure as code workflows and reusable modules using Terraform/OpenTofu and Spacelift."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Terraform Tooling"
   */
  TERRAFORM_TOOLING = 'TERRAFORM_TOOLING',
  /**
   * @protobufOption (description) = "Management and provisioning of Kubernetes (EKS) clusters and related resources."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Kubernetes Cluster Management"
   */
  K8S_CLUSTERS = 'K8S_CLUSTERS',
  /**
   * @protobufOption (description) = "Configuration and management of VPCs, gateways, ingress, and edge networking infrastructure."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Networking"
   */
  NETWORKING = 'NETWORKING',
  /**
   * @protobufOption (description) = "Monitoring, controlling, and attributing AWS infrastructure costs."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "AWS Cost Attribution"
   */
  AWS_COSTS = 'AWS_COSTS',
  /**
   * @protobufOption (description) = "DNS management using Cloudflare and Amazon Route53."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "DNS"
   */
  DNS = 'DNS',
  /**
   * @protobufOption (description) = "Content delivery network (CDN) management using Cloudflare and Fastly."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "CDN"
   */
  CDN = 'CDN',
  /**
   * @protobufOption (description) = "Object storage solutions including AWS S3 and Cloudflare R2."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Object Storage"
   */
  OBJECT_STORAGE = 'OBJECT_STORAGE',
  /**
   * @protobufOption (description) = "On-call and incident management tools, including PagerDuty, Rootly, and standard monitors."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "On-call Tooling"
   */
  ONCALL_TOOLS = 'ONCALL_TOOLS',
  /**
   * @protobufOption (description) = "Disaster recovery processes and business continuity planning."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Disaster Recovery"
   */
  DISASTER_RECOVERY = 'DISASTER_RECOVERY',
  /**
   * @protobufOption (description) = "Service mesh infrastructure and management using Linkerd."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Service Mesh"
   */
  SERVICE_MESH = 'SERVICE_MESH',
  /**
   * @protobufOption (description) = "GameDay tooling and processes, including fault injection services for resilience testing."
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @protobufOption (title) = "Game Day Tooling"
   */
  GAMEDAYS = 'GAMEDAYS',
  /**
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Remote Dev"
   */
  REMOTE_DEV = 'REMOTE_DEV',
  /**
   * @protobufOption (description) = "Configurations that change a user's experience when using messenger."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Messenger User Configurations"
   */
  MESSENGER_USER_CONFIGURATIONS = 'MESSENGER_USER_CONFIGURATIONS',
  /**
   * @protobufOption (description) = "General UI layout features in admin2, including retailer profile page and other layout components"
   * @protobufOption (pod) = FAIRE_POD_OPS_ENABLEMENT
   * @protobufOption (title) = "Admin Layout"
   */
  ADMIN_LAYOUT = 'ADMIN_LAYOUT',
  /**
   * @protobufOption (description) = "Surfacing information brands can use to vet retailers."
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Retailer Vetting"
   */
  RETAILER_VETTING = 'RETAILER_VETTING',
  /**
   * @protobufOption (description) = "Relating to off-Faire data matching for retailers to improve retailer onboarding and activation."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Retailer Off-Faire Match"
   */
  RETAILER_OFF_FAIRE_MATCH = 'RETAILER_OFF_FAIRE_MATCH',
  /**
   * @protobufOption (description) = "Workflow and activity management using the Temporal platform."
   * @protobufOption (pod) = FAIRE_POD_ORDERS_MIGRATION
   * @protobufOption (title) = "Temporal"
   */
  TEMPORAL = 'TEMPORAL',
  /**
   * @protobufOption (description) = "Program to incentivize a retailer to grow with Faire."
   * @protobufOption (pod) = FAIRE_POD_INSIDER
   * @protobufOption (title) = "Grow with faire"
   */
  GROW_WITH_FAIRE = 'GROW_WITH_FAIRE',
  /**
   * @protobufOption (description) = "The markets hub on our Brand Portal. It tells brands about upcoming events as well as past events. It also includes our markets analytics."
   * @protobufOption (pod) = FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES
   * @protobufOption (title) = "Market Hub"
   */
  MARKET_HUB = 'MARKET_HUB',
  /**
   * @protobufOption (description) = "The special type of Brand Promo that we use during Markets."
   * @protobufOption (pod) = FAIRE_POD_BRAND_CATALOG_GROWTH
   * @protobufOption (title) = "Market Promotions"
   */
  MARKET_PROMOTIONS = 'MARKET_PROMOTIONS',
  /**
   * @protobufOption (description) = "Tooling related to testing, such as test spec, data creation util"
   * @protobufOption (pod) = FAIRE_POD_UNASSIGNED
   * @protobufOption (title) = "Quality Tooling"
   */
  QUALITY_TOOLING = 'QUALITY_TOOLING',
  /**
   * @protobufOption (description) = "Test infrastructure, such as test distribution mechanism, sandbox and Playwright"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Test Infrastructure"
   */
  TEST_INFRA = 'TEST_INFRA',
  /**
   * @protobufOption (description) = "Sample service module for onboarding new engineers"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "Onboarding Project"
   */
  ONBOARDING_PROJECT = 'ONBOARDING_PROJECT',
  /**
   * @protobufOption (description) = "Infrastructure for executing the remote samurai AI agent workflows"
   * @protobufOption (pod) = FAIRE_POD_PLATFORM_PRODUCTIVITY
   * @protobufOption (title) = "SAMURAI"
   */
  SAMURAI = 'SAMURAI',
  /**
   * @protobufOption (description) = "Faire Funds is an employee program to encourage dogfooding and reporting issues"
   * @protobufOption (pod) = FAIRE_POD_UNASSIGNED
   * @protobufOption (title) = "Faire Funds Triage"
   */
  FAIRE_FUNDS_TRIAGE = 'FAIRE_FUNDS_TRIAGE',
  /**
   * @protobufOption (description) = "Allows brands to attribute sales reps to customers/orders"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "Brand sales rep attribution"
   */
  BRAND_SALES_REP_ATTRIBUTION = 'BRAND_SALES_REP_ATTRIBUTION',
  /**
   * @protobufOption (description) = "Infrastructure that powers Next.js services such as middleware, data fetching, and caching"
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "Next.js Infrastructure"
   */
  NEXTJS_INFRASTRUCTURE = 'NEXTJS_INFRASTRUCTURE',
  /**
   * @protobufOption (description) = "The base infrastructure for connecting Faire to QuickBooks online for 2-way data sync."
   * @protobufOption (pod) = FAIRE_POD_FINANCIAL_PRODUCTS
   * @protobufOption (title) = "QuickBooks Accounting Sync"
   */
  QUICKBOOKS_ACCOUNTING_SYNC = 'QUICKBOOKS_ACCOUNTING_SYNC',
  /**
   * @protobufOption (description) = "General framework used for decentralizing app modals."
   * @protobufOption (pod) = FAIRE_POD_WEB_PLATFORM
   * @protobufOption (title) = "App Modal Framework"
   */
  APP_MODAL_FRAMEWORK = 'APP_MODAL_FRAMEWORK',
  /**
   * @protobufOption (description) = "Covers everything related to the end-to-end signup journey, including onboarding steps, eligibility checks, and account creation logic"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ONBOARDING
   * @protobufOption (title) = "Signup Flow"
   */
  SIGNUP_FLOW = 'SIGNUP_FLOW',
  /**
   * @protobufOption (description) = "Covers the UI/UX and functionality specific to any modal/dialog components that facilitate signup within the app"
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACQUISITION
   * @protobufOption (title) = "Signup Modal"
   */
  SIGNUP_MODAL = 'SIGNUP_MODAL',
  /**
   * @protobufOption (description) = "Retailer-to-Brand request to shop functionality"
   * @protobufOption (pod) = FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT
   * @protobufOption (title) = "R2B Request to Shop"
   */
  R2B_REQUEST_TO_SHOP = 'R2B_REQUEST_TO_SHOP',
  /**
   * @protobufOption (description) = "Features related to retailer activation checklist and onboarding guidance."
   * @protobufOption (pod) = FAIRE_POD_RETAILER_ACTIVATION
   * @protobufOption (title) = "Retailer Activation Checklist"
   */
  RETAILER_ACTIVATION_CHECKLIST = 'RETAILER_ACTIVATION_CHECKLIST',
  /**
   * @protobufOption (description) = "Features related to the Revenue (Sales) team, including BSMs, BP, and Retailer Sales."
   * @protobufOption (pod) = FAIRE_POD_SECURITY
   * @protobufOption (title) = "Revenue Team"
   */
  REVENUE_TEAM = 'REVENUE_TEAM',
}
